import React from "react";
import DashboardIcon from "../../../assets/images/dashboard.png";
import GroupsIcon from "../../../assets/images/groups.png";
import UserIcon from "../../../assets/images/user.png";
import ReportsIcon from "../../../assets/images/reports.png";
import { Email } from "@material-ui/icons";
import HistoryIcon from "@material-ui/icons/History";

export const menus = [
  {
    id: "dashboard",
    title: "Dashboard",
    icon: DashboardIcon,
    path: "/org",
  },
  {
    id: "groups",
    title: "Groups",
    icon: GroupsIcon,
    path: "/org/groups",
    sub: "/org/group/manage",
  },
  {
    id: "users",
    title: "Users",
    icon: UserIcon,
    path: "/org/users",
  },
  {
    id: "invitation",
    title: "Invite Users",
    muiIcon: () => <Email style={{ margin: 0 }} />,
    path: "/org/invitation",
  },
  /* {
    id: "activity",
    title: "Activity",
    icon: ActivityIcon,
    path: "/org/activities",
  }, */
  {
    id: "reports",
    title: "Reports",
    icon: ReportsIcon,
    path: "/org/reports",
  },
  {
    id: "billing-history",
    title: "Billing History",
    muiIcon: () => <HistoryIcon style={{ margin: 0 }} />,
    path: "/org/billing-history",
  },
];
